import { useState } from "react";
import { TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function PromotionCandidateList({ candidates, renderCandidate, stage, resetKey = "" }) {
  const { t } = useTranslation("freigabe");
  const [paging, setPaging] = useState({ key: resetKey, page: 0, rows: 20 });
  const rows = paging.rows;
  const page = Math.min(paging.key === resetKey ? paging.page : 0, Math.max(0, Math.ceil(candidates.length / rows) - 1));
  return <>
    <div className={stage ? "promotion-stage-items" : "promotion-candidates"} role="list">
      {candidates.slice(page * rows, (page + 1) * rows).map(row => <div role="listitem" key={row.id} className="promotion-stage-item">{renderCandidate(row, stage)}</div>)}
    </div>
    {candidates.length > 20 && <TablePagination component="div" className="promotion-pagination" count={candidates.length}
      page={page} rowsPerPage={rows} rowsPerPageOptions={[20, 50, 100]}
      onPageChange={(_, value) => setPaging({ key: resetKey, page: value, rows })}
      onRowsPerPageChange={event => setPaging({ key: resetKey, page: 0, rows: Number(event.target.value) })}
      labelRowsPerPage={t("topics.rowsPerPage")} labelDisplayedRows={({ from, to, count }) => t("topics.pageRange", { from, to, count })}
      getItemAriaLabel={type => t(`topics.page.${type}`)}/>}
  </>;
}
